import * as Yup from "yup";
import moment from "moment";

export const YUPValidations = Yup.object().shape({
  providerName: Yup.string()
    .required("Field is required")
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  // centerType: Yup.string().required("Center type is required"),
  // visitSupport: Yup.string().required("Visit type is required"),
  // yearEstablish: Yup.string().required("Field is required"),
  // displayProviderName: Yup.string(/^[A-Za-z ]*$/)
  //   // .required("Field is required")
  //   .nullable()
  //   .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces")
  //   .matches(
  //     /^[^!@#$%^&*()_+={}\[\]:;<>,.?~\\/-]*$/,
  //     "Special characters are not allowed"
  //   ),
  displayProviderName: Yup.string()
    // .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces")
    .matches(
      /^[^!@#$%^&*_+={}\[\]:;<>,.?~\\/-]*$/,
      "Special characters are not allowed"
    )
    .test('no-numbers-after-space', 'Numbers are not allowed after a space', function (value) {
      const regex = / \d/;
      return !regex.test(value);
    })
    .test(
      "no-words",
      "Display name should not contain - Sector, Number after space, sec, colony, gali, nagar, marg, near, by, Private, limited, PVT, PVT. ,  LTD, LTD. , Layout, block, Mall, LLP, P Ltd, Special Characters, post, office, C/O, Stadium .",
      (value) => {
        // List of words to check for
        const wordsToCheck = [
          "Sector",
          "sec",
          "colony",
          "gali",
          "nagar",
          "marg",
          "near",
          "by",
          "Private",
          "limited",
          "PVT",
          "PVT.",
          "LTD",
          "LTD.",
          "Layout",
          "block",
          "Mall",
          "LLP",
          "P Ltd",
          "post",
          "office",
          "C/O",
          "Stadium",
        ];
        const wordPattern = new RegExp(
          `\\b(${wordsToCheck.join("|")})\\b`,
          "i"
        );
        return !wordPattern.test(value);
      }
    ),
  areaName: Yup.string(/^[A-Za-z ]*$/)
    // .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces")
    .matches(
      /^[^!@#$%^&*()_+={}\[\]:;<>,.?~\\/-]*$/,
      "Special characters are not allowed"
    ),
  authorizedPersonName: Yup.string(/^[A-Za-z ]*$/)
    // .required("Field is required")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  registeredMobileNo: Yup.string()
    .min(10, "Registered mobile no must be equal to 10.")
    .max(10, "Registered mobile no must be equal to 10.")
    .matches(/^\d+$/, "The field should have digits only"),
  // .required("Field is required"),
  additionalMobileNo: Yup.string()
    .min(10, "additional mobile no must be equal to 10.")
    .max(10, "additional mobile no must be equal to 10.")
    .matches(/^\d+$/, "The field should have digits only"),
  // .required("Field is required"),
  registeredEmailID: Yup.string().email(
    "Registered email address must be a valid email"
  ),
  // .required("Field is required"),
  officialWebsite: Yup.string().matches(
    /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
    "Enter correct url!"
  ),
  houseName: Yup.string().matches(
    /^(?!\s+$)/,
    "This field cannot contain only blank spaces"
  ),
  // .required("Field is required"),
  houseNumber: Yup.string().matches(
    /^(?!\s+$)/,
    "This field cannot contain only blank spaces"
  ),
  // .required("Field is required"),
  address1: Yup.string().matches(
    /^(?!\s+$)/,
    "This field cannot contain only blank spaces"
  ),
  // .required("Field is required"),
  address2: Yup.string().matches(
    /^(?!\s+$)/,
    "This field cannot contain only blank spaces"
  ),
  // stateName: Yup.string().required("Field is required"),
  // city: Yup.string().required("Field is required"),
  pincode: Yup.string()
    .min(6, "pincode must be equal to 6.")
    .max(6, "pincode must be equal to 6.")
    .matches(/^\d+$/, "The field should have digits only"),
  // .required("Field is required"),
  landmark: Yup.string().matches(
    /^(?!\s+$)/,
    "This field cannot contain only blank spaces"
  ),
  // .required("Field is required"),
  googleMyBusinessLink: Yup.string().matches(
    /^(?!\s+$)/,
    "This field cannot contain only blank spaces"
  ),
  bajajFinservLink: Yup.string().matches(
    /^(?!\s+$)/,
    "This field cannot contain only blank spaces"
  ),
  getVisitLink: Yup.string().matches(
    /^(?!\s+$)/,
    "This field cannot contain only blank spaces"
  ),
  ekaCareLink: Yup.string().matches(
    /^(?!\s+$)/,
    "This field cannot contain only blank spaces"
  ),
  practoLink: Yup.string().matches(
    /^(?!\s+$)/,
    "This field cannot contain only blank spaces"
  ),
});

export const isValidDate = (current) => {
  const year = current.year();
  const month = current.month();
  return (
    year <= year &&
    ((year == moment().year() && month <= moment().month()) ||
      year < moment().year())
  );
};

export const formatToCapitalizedWords = (inputValue) => {
  const words = inputValue.split(/\s+/);
  const capitalizedWords = words.map((word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
  return capitalizedWords.join(" ");
};
